import { useSelector } from "react-redux";
import { getFeedbackForm } from "../../../redux/reducer/incbotFeedbackReducer";
import { QUESTION_TYPES } from "../../../constants";
import SpecificQuestion from "./SpecificQuestion";

export const GeneralQuestionsSection = () => {
  const feedbackForm = useSelector(getFeedbackForm);
  const generalQuestions = (feedbackForm?.questions?.data || [])?.filter(
    (question: any) => question.questionType === QUESTION_TYPES.GLOBAL
  );

  const renderQuestions = (questions: any[], startIndex = 0) => {
    return questions.map((question, index) => {
      // Map the custom question format to SpecificQuestion props
      const questionProps = {
        key: question._id || index,
        timeTaken: question.timeTaken,
        questionNumber: startIndex + index + 1,
        questionText: question.question,
        transcript: question.answer,
        conversation: [
          ...(Array.isArray(question.conversationAIQuestions)
            ? question.conversationAIQuestions.map((item: any) => ({
                question: item.question,
                answer: item.answer,
                ratingReason: item.ratingReason,
              }))
            : []),
          ...(Array.isArray(question.follow_up_questions)
            ? question.follow_up_questions.map((item: any) => ({
                question: item.question,
                answer: item.answer,
                ratingReason: item.aiResponseAnalysis,
              }))
            : []),
        ]
          .filter((followUp: any, index: number, arr: any[]) =>
            arr.findIndex((f: any) => f.question === followUp.question) === index
          )
          .map((followUp: any) => [
            {
              type: "question",
              content: followUp.question,
              isCandidate: false,
            },
            {
              type: "transcript",
              content: followUp.answer,
              aiResponse: followUp.ratingReason,
              isCandidate: true,
            },
          ])
          .flat(),
        isGeneral: true,
      };

      return <SpecificQuestion {...questionProps} />;
    });
  };

  return (
    <>
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-sm p-4 md:p-6 mb-3 md:mb-6 border border-blue-100">
        <h1 className="text-lg md:text-xl lg:text-2xl font-semibold text-gray-900 mb-1 md:mb-2">
          General Questions
        </h1>
        <p className="text-gray-600 text-xs md:text-sm lg:text-base">
          Overview of the candidate's basic skills, communication, and overall attitude
        </p>
      </div>

      <div className="mb-3 md:mb-6">{renderQuestions(generalQuestions)}</div>
    </>
  );
};
